import { API } from "@/lib/api";

async function call(path, { method = "GET", body, raw = false } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (raw) return res;
  let payload = null;
  try {
    payload = await res.json();
  } catch {
    /* */
  }
  if (!res.ok) {
    const err = new Error(payload?.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const privacyApi = {
  getConsent: () => call("/privacy/training-consent"),
  setConsent: (consent) =>
    call("/privacy/training-consent", { method: "POST", body: { consent } }),
};

/**
 * Trigger a browser download of a conversation in the chosen format.
 * For logged-in users: hits /api/conversations/:id/export (server-stored).
 * For anonymous users: posts the in-memory conversation to the anon export
 * endpoint, which never persists it.
 */
export async function exportConversation({ conversation, format, anonymous = false }) {
  const fmt = (format || "").toLowerCase();
  let res;
  const exportInMemory = () => fetch(`${API}/anon/conversations/export?format=${encodeURIComponent(fmt)}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(conversation),
  });
  if (anonymous) {
    res = await exportInMemory();
  } else {
    res = await fetch(
      `${API}/conversations/${encodeURIComponent(conversation.id)}/export?format=${encodeURIComponent(fmt)}`,
      { credentials: "include" }
    );
    if (res.status === 404 && (conversation?.messages || []).length > 0) {
      res = await exportInMemory();
    }
  }
  if (!res.ok) {
    let detail = "";
    try {
      const body = await res.json();
      detail = body?.detail || "";
    } catch {
      /* */
    }
    throw new Error(detail || `Export failed (${res.status})`);
  }
  const blob = await res.blob();
  const cd = res.headers.get("content-disposition") || "";
  const match = cd.match(/filename="?([^";]+)"?/i);
  const filename = match
    ? match[1]
    : `${(conversation.title || "conversation").replace(/[^A-Za-z0-9_-]+/g, "_") || "conversation"}.${fmt}`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
